<div style="width: 100%; height: 90%" align="center">
  <div *ngIf="filterMode">
    <h1 align="center">
      <a
        style="cursor: pointer; padding-left: 15px"
        (click)="actOverNodeGlobalAlarms('silenciar', uuid, nodeType)"
        title="Silenciar todas las alarmas de la tabla"
      >
        <mat-icon style="color: rgb(255, 191, 0)">volume_off</mat-icon>
      </a>
      <a
        style="cursor: pointer; padding: 10px"
        (click)="actOverNodeGlobalAlarms('rearmar', uuid, nodeType)"
        title="Rearmar todas las alarmas de la tabla"
      >
        <mat-icon style="color: green">volume_up</mat-icon>
      </a>
      {{ data.title }} {{ filterMode }}
    </h1>
  </div>

  <hr />

  <div
    class="mat-elevation-z8"
    *ngIf="componentMode == 'source'"
    style="margin-bottom: 5px"
  >
    <table mat-table [dataSource]="dataSource">
      <ng-container matColumnDef="acciones">
        <th mat-header-cell *matHeaderCellDef><b> </b></th>
        <td mat-cell *matCellDef="let d">
          <a
            *ngIf="componentMode != 'source'"
            (click)="emitEventToInfoComponent(d)"
          >
            <i class="material-icons search">search</i>
          </a>
          <span
            *ngIf="nodeAlarmsArray"
            matBadge="{{ nodeAlarmsArray.length }}"
            matBadgeOverlap="true"
          ></span>
          <a
            style="cursor: pointer; padding-left: 15px"
            (click)="actOverNodeRowAlarms('silenciar', d.uuid, 'source')"
            title="Silenciar alarma"
          >
            <mat-icon style="color: rgb(255, 191, 0)">volume_off</mat-icon>
          </a>
          <a
            style="cursor: pointer; padding: 10px"
            (click)="actOverNodeRowAlarms('rearmar', d.uuid, 'source')"
            title="Rearmar alarma"
          >
            <mat-icon style="color: green">volume_up</mat-icon>
          </a>
        </td>
      </ng-container>

      <ng-container matColumnDef="gateway">
        <th mat-header-cell *matHeaderCellDef><b>Dispositivo</b></th>
        <td mat-cell *matCellDef="let d">
          <span
            *ngIf="d.alarmadosCount"
            matBadge="{{ d.alarmadosCount }}"
            matBadgeOverlap="true"
            ><i class="material-icons alarm">new_releases</i></span
          >
          <a
            style="padding-left: 25px"
            [routerLink]="['/source', d.uuid]"
            title="Navegar al elemento {{ d.lastEntrada?.dato.tiene?.nombre }}"
          >
            {{ d.lastEntrada?.dato.tiene?.nombre }}
          </a>
        </td>
      </ng-container>

      <ng-container matColumnDef="estadoAlarmas">
        <th mat-header-cell *matHeaderCellDef>
          <b>Cantidad de datos {{ filterMode }}s</b>
        </th>
        <td mat-cell *matCellDef="let d">
          <span *ngIf="filterMode == 'alarmado'">
            {{ d.datosAlarmados }} / {{ d.datosConEntradas }}
          </span>
          <span *ngIf="filterMode == 'silenciado'">
            {{ d.datosSilenciados }} / {{ d.datosConEntradas }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="fecha_evento">
        <th mat-header-cell *matHeaderCellDef><b>Fecha del evento</b></th>
        <td mat-cell *matCellDef="let d">
          {{ d.lastEntrada?.dato.alarmado | getDatePipe }}
        </td>
      </ng-container>

      <ng-container matColumnDef="lastFecha">
        <th mat-header-cell *matHeaderCellDef>
          <b>Última fecha de envío de datos</b>
        </th>
        <td mat-cell *matCellDef="let d">
          {{ d.lastEntrada?.dato.lastFecha | getDatePipe }}
        </td>
      </ng-container>

      <ng-container matColumnDef="lastValor">
        <th mat-header-cell *matHeaderCellDef>
          <b>Último valor registrado</b>
        </th>
        <td mat-cell *matCellDef="let d">
          {{ d.lastEntrada?.dato.lastValor }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        [ngClass]="{
          trWarning: row.sourcesRezagados > 0,
          trError: row.sourcesTotal == 0
        }"
      ></tr>
    </table>
  </div>
  <!-- TODO: Revisar -->
  <!-- <ng-template #elseSilenciadosBlock>
    {{ d.datosSilenciados }} / {{ d.datosConEntradas }}
  </ng-template> -->

  <div
    class="mat-elevation-z8"
    *ngIf="componentMode == 'entrada'"
    style="margin-bottom: 5 px"
  >
    <table mat-table [dataSource]="dataSource">
      <ng-container matColumnDef="acciones">
        <th mat-header-cell *matHeaderCellDef><b> </b></th>
        <td mat-cell *matCellDef="let d">
          <a (click)="emitEventToInfoComponent(d)">
            <i class="material-icons search">search</i>
          </a>
          <span
            *ngIf="nodeAlarmsArray"
            matBadge="{{ nodeAlarmsArray.length }}"
            matBadgeOverlap="true"
          ></span>
          <a
            style="cursor: pointer; padding-left: 15px"
            (click)="actOverNodeRowAlarms('silenciar', d.uuid, 'dato')"
            title="Silenciar alarma"
          >
            <mat-icon style="color: rgb(255, 191, 0)">volume_off</mat-icon>
          </a>
          <a
            style="cursor: pointer; padding: 10px"
            (click)="actOverNodeRowAlarms('rearmar', d.uuid, 'dato')"
            title="Rearmar alarma"
          >
            <mat-icon style="color: green">volume_up</mat-icon>
          </a>
        </td>
      </ng-container>

      <ng-container matColumnDef="dispositivo">
        <th mat-header-cell *matHeaderCellDef><b>Dispositivo</b></th>
        <td mat-cell *matCellDef="let d">
          <span
            *ngIf="d.alarmadosCount"
            matBadge="{{ d.alarmadosCount }}"
            matBadgeOverlap="true"
            ><i class="material-icons alarm">new_releases</i></span
          >
          {{ d.tiene?.nombre }}
        </td>
      </ng-container>

      <ng-container matColumnDef="tipoDato">
        <th mat-header-cell *matHeaderCellDef><b>Tipo de medición</b></th>
        <td mat-cell *matCellDef="let d">
          <a
            style="padding-left: 25px"
            [routerLink]="['/dato', d.uuid]"
            title="Navegar al elemento {{ d.es?.nombre_es }}"
          >
            {{ d.es?.nombre_es }}
          </a>
        </td>
      </ng-container>

      <ng-container matColumnDef="fecha_evento">
        <th mat-header-cell *matHeaderCellDef><b>Fecha de evento</b></th>
        <td mat-cell *matCellDef="let d">
          {{ d.alarmado * 1000000 | getDatePipe }}
        </td>
      </ng-container>

      <ng-container matColumnDef="ack">
        <th mat-header-cell *matHeaderCellDef><b>Ack</b></th>
        <td mat-cell *matCellDef="let d">
          {{ (d.silenciado | getDatePipe) || "Sin fecha registrada" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="lastFecha">
        <th mat-header-cell *matHeaderCellDef>
          <b>Última fecha de envío de datos</b>
        </th>
        <td mat-cell *matCellDef="let d">
          {{ d.lastFecha | getDatePipe }}
        </td>
      </ng-container>

      <ng-container matColumnDef="lastValor">
        <th mat-header-cell *matHeaderCellDef>
          <b>Último valor registrado</b>
        </th>
        <td mat-cell *matCellDef="let d">
          {{ d.lastValor | getToFixed }}
        </td>
      </ng-container>

      <ng-container matColumnDef="unidad">
        <th mat-header-cell *matHeaderCellDef><b>Unidad</b></th>
        <td mat-cell *matCellDef="let d">
          {{ d.es.unidad }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        [ngClass]="{
          trWarning: row.sourcesRezagados > 0,
          trError: row.sourcesTotal == 0
        }"
      ></tr>
    </table>
  </div>

  <mat-paginator
    #TableGatewayRaizPaginator="matPaginator"
    [pageSizeOptions]="[5, 15, 30, 50]"
    showFirstLastButtons
    [hidden]="componentMode == 'dato'"
  >
  </mat-paginator>

  <div class="alarm-detail-info" [hidden]="componentMode == 'dato'">
    <app-node-alarm-info
      [events]="eventsSubject.asObservable()"
      [componentMode]="componentMode"
    ></app-node-alarm-info>
  </div>

  <div *ngIf="componentMode == 'dato'" style="margin-bottom: 5px">
    <app-node-alarm-info
      [componentMode]="componentMode"
      [uuid]="uuid"
    ></app-node-alarm-info>
  </div>

  <div style="margin-top: 15px">
    <button
      mat-raised-button
      style="background-color: blue; color: white; margin-left: 10px"
      mat-dialog-close
      cdkFocusInitial
      (click)="closeModal()"
    >
      {{ "CONFIRM_MODAL.ACCEPT" | translate }}
    </button>
  </div>

  <ng-template #spinnerBlock>
    <app-loading [loadingText]="'Cargando datos...'"></app-loading>
  </ng-template>
</div>
